<script setup lang="ts">
import {Quote, Star} from "lucide-vue-next";

import "@/assets/styles/review.css";

const reviews = [
  {
    name: "Familie Schneider",
    text: "Von der Beratung bis zur Umsetzung lief alles professionell und zuverlässig. Unser Garten sieht fantastisch aus.",
  },
  {
    name: "Michael Bauer",
    text: "Saubere Arbeit, pünktlich und sehr freundlich. Besonders die Pflasterarbeiten wurden perfekt umgesetzt.",
  },
  {
    name: "Sandra Keller",
    text: "Wir sind begeistert vom neuen Sichtschutz und der Gestaltung unseres Gartens. Absolute Empfehlung.",
  }
];
</script>

<template>

  <section class="reviews-section" id="reviews">

    <!-- Header -->
    <div class="reviews-header">

      <span class="section-badge">
        Kundenbewertungen
      </span>

      <h2>
        Das sagen unsere Kunden
      </h2>

      <p>
        Zufriedene Kunden und erfolgreiche Projekte
        stehen bei uns an erster Stelle.
      </p>

    </div>

    <!-- Bewertungen -->
    <div class="reviews-grid">

      <div
          class="review-card"
          v-for="review in reviews"
          :key="review.name"
      >

        <div class="quote-icon">
          <Quote/>
        </div>

        <div class="stars">
          <Star v-for="star in 5" :key="star"/>
        </div>

        <p class="review-text">
          "{{ review.text }}"
        </p>

        <div class="review-author">
          {{ review.name }}
        </div>

      </div>

    </div>

  </section>

</template>

<style scoped>
</style>